import React, { useEffect, useState } from 'react';
import './Pay.css';
import back_arrow from '../../Assets/Icons/back_arrow.png';
import logo from '../../Assets/Images/logo.png';
import { useNavigate } from 'react-router-dom';
import callApi from '../../util/callApi';
import { useDispatch } from 'react-redux';
import { ResetState } from '../../appActions';
import CheckoutForm from '../../Components/CheckoutForm';
import logout_logo from '../../Assets/Icons/logout.png';
import storageService from '../../util/storageService';
import configVariables from '../../util/constants';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    
    backgroundColor: 'rgba(47, 47, 47, 1)',
    boxShadow: '0px 7.2px 10.8px 5.4px rgba(0, 0, 0, 0.15), 0px 3.6px 3.6px rgba(0, 0, 0, 0.3)',
    borderRadius: '8px',
    border: 'none',
    color: 'white',
    height: '50px',
    width: '100%',
    gridArea: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px'
    
  }),
  menu: (provided) => ({
    ...provided,
        background:'rgba( 76, 76, 76, 0.65 )',
    backdropFilter:'blur( 9.5px )',
    borderRadius: '10px',
    border: '1px solid rgba( 255, 255, 255, 0.18 )',
    // backgroundColor: '#4a4948',
    fontSize:'12px',
    
    // border:'1px solid #7469B6',
    color: 'white',
    fontSize:'12px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'white',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '' : 'transparent',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#303043',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'white',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'white',
    ':hover': {
      backgroundColor: '#FB493F',
      color: 'white',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'white',
  }),
};

function Pay({ showLogOut }) {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [checkoutFormModal, setCheckoutFormModal] = useState(false);
  const [plans, setPlans] = useState([]);
  const[plan, setSelectedPlan] = useState({});
  
  // const [subscription, setSubscription] = useState({});
  const [additionalUsers, setAdditionalUsers] = useState(1);
  const [selectedTotalPrice, setSelectedTotalPrice] = useState(0);
const [selectedDevicesForCheckout, setSelectedDevicesForCheckout] = useState([]);
const [autoPayEnabled, setAutoPayEnabled] = useState(false);
const [loadingPlanId, setLoadingPlanId] = useState(null);
const [freeTrialEligible, setFreeTrialEligible] = useState(false);
  
  const location = useLocation();
  const devices = location.state?.devices || [];
  const user = location.state?.User || {};
  
  const device = location.state?.device;
  const selectedDevices = device ? [device] : devices;
  const deviceIds = selectedDevices.map(d => d._id);
  const deviceCount = selectedDevices.length;

  useEffect(() => {
    if (plans.length === 0) {
      callApi('fetch_plans', 'post', {}).then(res => {
        if (res.status === 'Success') {
          // console.log('Plans:', res.data.plans);
          const transformedPlans = res.data.plans.map(plan => ({
            id: plan.id,
            name: plan.item.name,
            description: plan.item.description,
            price: plan.item.amount / 100, // Convert from paisa to INR
            recurring: `${plan.interval} ${plan.period}`,
            dataLimit: plan.notes?.dataLimit ,
            SMS: plan.notes?.SMS ,
            Call: plan.notes?.Call ,
            User: plan.notes?.User ,
          }));
          
          setPlans(transformedPlans);
          // console.log('Transformed plans:', transformedPlans);
        } else {
          alert("An error occurred. Please try again later!");
        }
      });
    }
  }, []);
  

  const handleSubscribe = (planItem) => {
    const now = new Date();
    const validDevices = selectedDevices.filter(device => {
      const validUptoDate = new Date(device.payment?.validUpto);
      const isYearlyPlan = planItem.name === '1 Years Plan';
      return !device.subscriptionId || validUptoDate <= now || !isYearlyPlan;
    });
    // console.log('Valid devices:', validDevices);
    

  const isAddonPlan =
    planItem.name === 'Additional 5.2 Lakh Data Pack' ||
    planItem.name === 'Additional 1.04 Lakh Data Pack';

  if (isAddonPlan) {
    // Check if every selected device has a valid subscription
    const anyDeviceInvalid = selectedDevices.some(device => {
      const validUptoDate = new Date(device.payment?.validUpto);
      return !validUptoDate || isNaN(validUptoDate) || validUptoDate <= now;
    });

    if (anyDeviceInvalid) {
      alert('All selected devices must have an active subscription to purchase an Addon pack.');
      return;
    }
  }
  
    if (validDevices.length === 0) {
      alert("All selected devices already have an active subscription.");
      return;
    }
    setLoadingPlanId(planItem.id);
    const isAddon3 = planItem.name === "Additional Account";
    const isOneYearPlan = planItem.name === "1 Years Plan";
    const basePrice = isOneYearPlan && isFreeTrialEligible ? 0 : planItem.price;
 
  const totalPrice = isAddon3 ? basePrice * additionalUsers : basePrice * deviceCount;
  setSelectedTotalPrice(totalPrice);
  
  setSelectedDevicesForCheckout(deviceIds);
  setSelectedPlan(planItem);
  if (isOneYearPlan && isFreeTrialEligible) {
    setFreeTrialEligible(true);
  }
    
    setCheckoutFormModal(true);
  };
 

  const logOut = () => {
    storageService.remove(configVariables.USER_ID);
    storageService.remove(configVariables.USER_ROLE);
    storageService.remove(configVariables.USER_JWT_TOKEN);
    dispatch(ResetState());
    nav('/login');
  };
  const isFreeTrialEligible = selectedDevices.every(device =>
    device.payment?.planName === null &&
    device.payment?.status === "inactive" &&
    device.payment?.validUpto === null &&
    device.payment?.planId === null &&
    device.payment?.dataUsage === null&&
    user.accountType === "Product Based"
  );
  
  return (
    <div className='pricing-table-top'>
      <div className='pricing-table-head'>
        <h1>
          <img src={back_arrow} onClick={() => nav('/subscription_details')} alt='Back' />
          Select a Plan
        </h1>
        <div className='pay-table-head-right'>
          {showLogOut && (
            <p onClick={logOut}>
              <img src={logout_logo} alt='Logout' /> Logout
            </p>
          )}
          <img src={logo} alt='Logo' />
        </div>
      </div>
      <div className='pricing-table'>
      {plans
        .filter((plan) => plan.description.toLowerCase() === user.accountType.toLowerCase())
        .map((planItem) => {
          const isAddon3 = planItem.name === "Additional Account";
          // const basePrice = planItem.price;
          const isOneYearPlan = planItem.name === "1 Years Plan";
          const basePrice =  planItem.price;
          const totalPrice = isAddon3 ? basePrice * additionalUsers : basePrice * deviceCount;
          const now = new Date();
          const yearlyplan= planItem.name.toLowerCase().includes("year")
          const monthlyplan= planItem.name.toLowerCase().includes("month")
          const shouldHideYearly =
          (yearlyplan || monthlyplan) &&
            (
              selectedDevices.length === 0 ||
              selectedDevices.some(
                (device) =>
                  device.subscriptionId &&
                  new Date(device.payment?.validUpto) > now
              )
            );
          if (shouldHideYearly) {
            return null;
          }
          
          return (
            <div className='pay-card' key={planItem.id}>
              <div className='pay-card-head'>
              {planItem.name.toLowerCase().includes("year") ? (
                      <span className="badge yearly">Yearly Plan</span>
                    ) : planItem.name.toLowerCase().includes("month") ? (
                      <span className="badge monthly">Monthly Plan</span>
                    ) : (
                      <span className="badge addon">Addon Plan</span>
                    )}

                <h2 >{planItem.name}</h2>
              </div>
              <div className='pay-card-cont'>
              <p className='pay-card-cont-amnt'>
                  {isOneYearPlan && isFreeTrialEligible ? (
                    <span className="free-label">Free Trial</span>
                  ) : (
                    <>₹ {basePrice} {isAddon3 ? "per user" : "per device"}</>
                  )}
                </p>
                {isAddon3 ? (
                  <>
                    
                    <Select
                        placeholder="Number of Additional Users"
                        value={{ value: additionalUsers, label: additionalUsers }}
                        styles={customStyles}
                        options={[1, 2, 3, 4, 5].map((num) => ({ value: num, label: num }))}
                        onChange={(selectedOption) => setAdditionalUsers(selectedOption.value)}
                        isSearchable={false}
                      />
                    

                   
                  </>
                ) : (
                  <p className='pay-card-cont-amnt'>Selected Devices: {deviceCount}</p>
                )}
                <p className='pay-card-cont-final'>
                    {isOneYearPlan && isFreeTrialEligible ? (
                      <>
                        <span style={{ textDecoration: 'line-through', color: '#888', marginRight: '8px' }}>
                          ₹{totalPrice.toFixed(2)}
                        </span>
                        <span className="free-label">Free</span>
                      </>
                    ) : (
                      <>₹ {totalPrice.toFixed(2)}</>
                    )}
                  </p>


                
              </div>
              {planItem && (
                <div className='pay-card-details'>
                  {planItem.dataLimit && <p><strong>Data Limit:</strong> {planItem.dataLimit.toLocaleString()} </p>}
                  {planItem.SMS && <p><strong>SMS:</strong> {planItem.SMS.toLocaleString()}+ messages</p>}
                  {planItem.Call && <p><strong>Call:</strong> {planItem.Call.toLocaleString()}</p>}
                  {planItem.User && <p><strong>Users</strong> : {planItem.User.toLocaleString()}</p>}
                  {planItem.user && <p><strong>User</strong> : {planItem.user}</p>}
                  {planItem.Message && <p><strong>SMS</strong> : {planItem.Message}</p>}
                  {planItem.calls && <p><strong>Calls</strong> : {planItem.calls}</p>}
                </div>
              )}
             {(planItem.name.toLowerCase().includes("year") || planItem.name.toLowerCase().includes("month")) && (

                  <div className="autopay-toggle-container">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={autoPayEnabled}
                        onChange={() => setAutoPayEnabled(!autoPayEnabled)}
                      />
                      <span className="slider round"></span>
                    </label>
                    <span className="autopay-label">Enable Auto-Payment</span>
                  </div>
                )}

              
              <button
                className='pay-card-but'
                onClick={() => handleSubscribe(planItem)}
                disabled={loadingPlanId === planItem.id}
              >
                {loadingPlanId === planItem.id
                  ? 'Loading...'
                  : isOneYearPlan && isFreeTrialEligible
                  ? 'Activate Free Trial'
                  : 'Subscribe'}

              </button>
            </div>
          );
        })}
      </div>
      {checkoutFormModal && <CheckoutForm setCloseModal={setCheckoutFormModal} devices={selectedDevicesForCheckout} plan={plan} totalPrice={selectedTotalPrice} additionalUsers={additionalUsers} autoPayEnabled={autoPayEnabled} freeTrialEligible={freeTrialEligible}/>}
    </div>
  );
}

export default Pay;